/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { bool, func, element } from 'prop-types';
import React, { Component, createRef } from 'react';

export default class ClickOffSensor extends Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  wrapperRef = createRef();

  handleClickOutside = (event) => {
    const { target } = event;
    const { isOpen, onClickOut } = this.props;
    if (
      this.wrapperRef &&
      this.wrapperRef.current !== target &&
      !this.wrapperRef.current.contains(target) &&
      isOpen
    ) {
      onClickOut(event);
    }
  };

  render() {
    return (
      <div ref={this.wrapperRef} className={this.props.className}>
        {this.props.children}
      </div>
    );
  }
}

ClickOffSensor.propType = {
  children: element,
  isOpen: bool,
  onClickOut: func.isRequired
};
